import { waitForButton } from "./waitForButton";
import { waitForElement } from "./waitForElement";
import { waitSomeTime } from "./waitSomeTime";

export const twoStepFeedTrigger = async (
  triggerButtonId: string,
  targetElementId: string,
  waitForSlide?: boolean,
) => {
  const triggerButton = await waitForButton(triggerButtonId);
  if (!triggerButton) return false;
  const elementFound = await waitForElement(targetElementId);
  if (elementFound && waitForSlide) await waitSomeTime();
  return elementFound;
};
